"use strict";

var _regeneratorRuntime = require("/vercel/612421a5/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var path = require("path");

var whatwgURL = require("whatwg-url");

var _require = require("./living/helpers/internal-constants"),
    domSymbolTree = _require.domSymbolTree;

var SYMBOL_TREE_POSITION = require("symbol-tree").TreePosition;

var _require2 = require("./living/helpers/document-base-url"),
    parseURLToResultingURLRecord = _require2.parseURLToResultingURLRecord;

exports.toFileUrl = function (fileName) {
  // Beyond just the `path.resolve`, this is mostly for the benefit of Windows,
  // where we need to convert "\" to "/" and add an extra "/" prefix before the
  // drive letter.
  var pathname = path.resolve(process.cwd(), fileName).replace(/\\/g, "/");

  if (pathname[0] !== "/") {
    pathname = "/" + pathname;
  } // path might contain spaces, so convert those to %20


  return "file://" + encodeURI(pathname);
};
/**
 * Define a getter on an object
 *
 * This method replaces any existing getter but leaves setters in place.
 *
 * - `object` {Object} the object to define the getter on
 * - `property` {String} the name of the getter
 * - `getterFn` {Function} the getter
 */


exports.defineGetter = function defineGetter(object, property, getterFn) {
  var descriptor = Object.getOwnPropertyDescriptor(object, property) || {
    configurable: true,
    enumerable: true
  };
  descriptor.get = getterFn;
  Object.defineProperty(object, property, descriptor);
};
/**
 * Define a set of properties on an object, by copying the property descriptors
 * from the original object.
 *
 * - `object` {Object} the target object
 * - `properties` {Object} the source from which to copy property descriptors
 */


exports.define = function define(object, properties) {
  var _iterator = _createForOfIteratorHelper(Object.getOwnPropertyNames(properties)),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var name = _step.value;
      var propDesc = Object.getOwnPropertyDescriptor(properties, name);
      Object.defineProperty(object, name, propDesc);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
};
/**
 * Define a list of constants on a constructor and its .prototype
 *
 * - `Constructor` {Function} the constructor to define the constants on
 * - `propertyMap` {Object}  key/value map of properties to define
 */


exports.addConstants = function addConstants(Constructor, propertyMap) {
  for (var property in propertyMap) {
    var value = propertyMap[property];
    addConstant(Constructor, property, value);
    addConstant(Constructor.prototype, property, value);
  }
};

function addConstant(object, property, value) {
  Object.defineProperty(object, property, {
    configurable: false,
    enumerable: true,
    writable: false,
    value: value
  });
}

exports.mixin = function (target, source) {
  var keys = Reflect.ownKeys(source);

  for (var i = 0; i < keys.length; ++i) {
    if (keys[i] in target) {
      continue;
    }

    Object.defineProperty(target, keys[i], Object.getOwnPropertyDescriptor(source, keys[i]));
  }
};

var memoizeQueryTypeCounter = 0;
/**
 * Returns a version of a method that memoizes specific types of calls on the object
 *
 * - `fn` {Function} the method to be memozied
 */

exports.memoizeQuery = function memoizeQuery(fn) {
  // Only memoize query functions with arity <= 2
  if (fn.length > 2) {
    return fn;
  }

  var type = memoizeQueryTypeCounter++;
  return function () {
    if (!this._memoizedQueries) {
      return fn.apply(this, arguments);
    }

    if (!this._memoizedQueries[type]) {
      this._memoizedQueries[type] = Object.create(null);
    }

    var key;

    if (arguments.length === 1 && typeof arguments[0] === "string") {
      key = arguments[0];
    } else if (arguments.length === 2 && typeof arguments[0] === "string" && typeof arguments[1] === "string") {
      key = arguments[0] + "::" + arguments[1];
    } else {
      return fn.apply(this, arguments);
    }

    if (!(key in this._memoizedQueries[type])) {
      this._memoizedQueries[type][key] = fn.apply(this, arguments);
    }

    return this._memoizedQueries[type][key];
  };
};

exports.reflectURLAttribute = function (elementImpl, contentAttributeName) {
  var attributeValue = elementImpl.getAttribute(contentAttributeName);

  if (attributeValue === null || attributeValue === "") {
    return "";
  }

  var urlRecord = parseURLToResultingURLRecord(attributeValue, elementImpl._ownerDocument);

  if (urlRecord === null) {
    return attributeValue;
  }

  return whatwgURL.serializeURL(urlRecord);
};

function isValidAbsoluteURL(str) {
  return whatwgURL.parseURL(str) !== null;
}

exports.isValidTargetOrigin = function (str) {
  return str === "*" || str === "/" || isValidAbsoluteURL(str);
};

exports.simultaneousIterators = /*#__PURE__*/_regeneratorRuntime.mark(function _callee(first, second) {
  var firstResult, secondResult;
  return _regeneratorRuntime.wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          firstResult = first.next();
          secondResult = second.next();

          if (!(firstResult.done && secondResult.done)) {
            _context.next = 4;
            break;
          }

          return _context.abrupt("return");

        case 4:
          _context.next = 6;
          return [firstResult.done ? null : firstResult.value, secondResult.done ? null : secondResult.value];

        case 6:
          _context.next = 0;
          break;

        case 8:
        case "end":
          return _context.stop();
      }
    }
  }, _callee);
});

exports.treeOrderSorter = function (a, b) {
  var compare = domSymbolTree.compareTreePosition(a, b);

  if (compare & SYMBOL_TREE_POSITION.PRECEDING) {
    // b is preceding a
    return 1;
  }

  if (compare & SYMBOL_TREE_POSITION.FOLLOWING) {
    return -1;
  } // disconnected or equal:


  return 0;
};
/* eslint-disable global-require */


exports.Canvas = null;
["canvas", "canvas-prebuilt"].some(function (moduleName) {
  try {
    exports.Canvas = require(moduleName);

    if (typeof exports.Canvas !== "function") {
      // In browserify, the require will succeed but return an empty object
      exports.Canvas = null;
    }
  } catch (e) {
    exports.Canvas = null;
  }

  return exports.Canvas !== null;
});